import {SystemNewsService} from '../services';
import {bindLoading} from './index';

export default {
    namespaced: true,
    state: {
        newsData: null,
        newsList: [],
        logData: null,
        logList: [],
        logChart: []
    },

    getters: {
        getNews(state) {
            return state.newsData;
        },
        getNewsList(state) {
            return state.newsList;
        },
        getLog(state) {
            return state.logData;
        },
        getLogList(state) {
            return state.logList;
        },
        getLogChart(state) {
            return state.logChart;
        }
    },

    mutations: {
        setSelectedData(state, form) {
            state.newsData = {...form};
        },
        saveSelectedList(state, form) {
          //state.newsList.splice(0);
          if (null === form) {
            state.newsList = [];
          } else {
            state.newsList = [...form];
          }
        },
        
        setLogData(state, form) {
            state.logData = {...form};
        },
        saveLogList(state, form) {
          if (null === form) {
            state.logList = [];
          } else {
            state.logList = [...form];
          }
        },
        saveLogChart(state, form) {
          if (null === form) {
            state.logChart = [];
          } else {
            state.logChart = [...form];
          }
        }
    },

    actions: {
        async clearNewsData({commit}) {
            commit('setSelectedData', null)
        },
        async clearNewsList({commit}) {
            commit('saveSelectedList', null)
        },

        async getNewsList({commit}) {
            return await bindLoading(commit,
                async () => {
                    const rst = await SystemNewsService.getAll();
                    
                    if (rst.success) {
                        commit('saveSelectedList', rst.instance)
                    }
                    return rst;
                }, 'systemNews')
        },
        
        async getNewsData({commit}, id) {
            return await bindLoading(commit,
                async () => {
                    const rst = await SystemNewsService.get(id);
                    if (rst.success) {
                        commit('setSelectedData', rst.instance)
                    }
                    return rst;
                }, 'systemNews')
        },
        
        async removeNewsData({commit, state}, id) {
            return await bindLoading(commit,
                async () => {
                    const res = await SystemNewsService.remove(id);
                    if (res.success) {
                        // commit('saveSelectedList', state.newsList.filter(f => !res.instance.find(r => r === f.newsId)));
                        commit('setSelectedData', null);
                    }
                    return res;
                }, 'systemNews');
        },

        async updateNewsData({commit, state}, item) {
            return await bindLoading(commit,
                async () => {
                    const res = await SystemNewsService.update(item);
                    if (res.success) {
                        state.newsData.newsId = res.instance;
                 /*        const idx = state.newsList.findIndex(m => m.newsId === item.newsId);
                        commit('saveSelectedList',
                            [
                                ...state.newsList.filter((_, i) => i < idx),
                                res.instance,
                                ...state.newsList.filter((_, i) => i > idx)
                            ]); */
                    }
                    return res;
                }, 'systemNews');
        },
        
        async getSystemNews({commit, state}, item) {
            return await bindLoading(commit,
                async () => {
                    const res = await SystemNewsService.getSystemNews(item);
                    if (res.success) {
                        commit('saveSelectedList', res.instance);
                    }
                    return res;
                }, 'systemNews');
        },

        async sendMailAction({commit, state}, item) {
            return await bindLoading(commit,
                async () => {
                    const res = await SystemNewsService.sendMail(item);
                    return res;
                }, 'systemNews');
        },
        
        async getLogList({commit}) {
            return await bindLoading(commit,
                async () => {
                    const rst = await SystemNewsService.getAllLog();
                    
                    if (rst.success) {
                        commit('saveLogList', rst.instance)
                    }
                    return rst;
                }, 'systemNews')
        },
        
        async getLogData({commit}, id) {
            return await bindLoading(commit,
                async () => {
                    const rst = await SystemNewsService.getLog(id);
                    if (rst.success) {
                        commit('setLogData', rst.instance)
                    }
                    return rst;
                }, 'systemNews')
        },
        
        async updateLogData({commit, state}, item) {
            return await bindLoading(commit,
                async () => {
                    const res = await SystemNewsService.updateLog(item);
                    if (res.success) {
                        state.logData.id = res.instance;
                    }
                    return res;
                }, 'systemNews');
        },
        
        async getLogByInfo({commit, state}, item) {
            return await bindLoading(commit,
                async () => {
                    const res = await SystemNewsService.getLogByInfo(item);
                    if (res.success) {
                        commit('saveLogList', res.instance);
                    } else {
                        commit('saveLogList', []);
                    }
                    return res;
                }, 'systemNews');
        },
        
        async getChartByInfo({commit, state}, item) {
            return await bindLoading(commit,
                async () => {
                    const res = await SystemNewsService.getChartByInfo(item);
                    if (res.success) {
                        commit('saveLogChart', res.instance);
                    } else {
                        commit('saveLogChart', []);
                    }
                    return res;
                }, 'systemNews');
        }
    }

}